import { ExpandMore } from '@mui/icons-material';
import DashboardCustomizeTwoToneIcon from '@mui/icons-material/DashboardCustomizeTwoTone';
import { Collapse, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import Icon from '@mui/material/Icon';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LIGHT_GREY_COLOR } from '../../_const/color.const';
import { ADMIN_NAV, PRIMARY_ADMIN_NAV, PRIMARY_ORGANISER_NAV, toAppAbsolutePath, USER_NAV } from '../../_const/navigation.const';
import { accountService } from '../../_services/accounts.service';

const logoImg = require('../../_assets/images/Logo-Standard.png');
const drawerWidth = 240;

export default function AppSidebar(params: { isOpen: boolean }) {
    let navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(params.isOpen);
    const [userNavOpen, setUserNavOpen] = useState(false);


    useEffect(() => {
        setIsOpen(params.isOpen);
    }, [params.isOpen]);

    return (
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                "& .MuiPaper-root": {
                    width: drawerWidth
                }
            }}
            variant="persistent"
            open={isOpen}
            id={"sidebarNavDrawer"}
            anchor="left">

            <div>
                <img style={{
                    width: "180px",
                    height: "105px",
                    marginTop: "10px",
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: "10px"
                }} src={logoImg} alt={"test"}></img>
            </div>

            <Divider />

            {(accountService.isOrganiser && PRIMARY_ORGANISER_NAV.length > 0) &&
                <List>
                    {PRIMARY_ORGANISER_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => navigate(toAppAbsolutePath(nav.url))}>
                            <ListItemIcon sx={{ minWidth: "40px" }}>
                                <Icon>{nav.icon}</Icon>
                            </ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                    <Divider />
                </List>
            }

            {(accountService.isAdmin && PRIMARY_ADMIN_NAV.length > 0) &&
                <List>
                    {PRIMARY_ADMIN_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => navigate(toAppAbsolutePath(nav.url))}>
                            <ListItemIcon sx={{ minWidth: "40px" }}>
                                <Icon>{nav.icon}</Icon>
                            </ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                    <Divider />
                </List>
            }

            {(accountService.isAdmin && ADMIN_NAV.length > 0) &&
                <List
                    sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                    component="nav"
                    aria-labelledby="nested-list-subheader">

                    <ListItemButton key={"AdminDashboard"} onClick={(e) => setUserNavOpen(!userNavOpen)}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <DashboardCustomizeTwoToneIcon />
                        </ListItemIcon>
                        <ListItemText primary="Admin Dashboard" />
                        {userNavOpen ? <ExpandMore /> : <Icon>chevron_right</Icon>}
                    </ListItemButton>

                    <Collapse in={userNavOpen} timeout="auto" unmountOnExit>
                        <List component="div">
                            {ADMIN_NAV.map(nav =>

                                <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} key={nav.name} onClick={e => navigate(toAppAbsolutePath(nav.url))}>
                                    <>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon fontSize="small" color="disabled">{nav.icon}</Icon>
                                        </ListItemIcon>

                                        <ListItemText
                                            primaryTypographyProps={{ fontSize: '14px' }}
                                            primary={nav.name} />
                                    </>
                                </ListItemButton>
                            )}

                        </List>
                    </Collapse>
                </List>
            }


            {(USER_NAV.length > 0) &&
                <List>
                    <Divider />

                    {USER_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={nav.onClick}>
                            <ListItemIcon sx={{ minWidth: "40px" }}>
                                <Icon>{nav.icon}</Icon>
                            </ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                    <Divider />

                </List>
            }
        </Drawer>
    );
}